import React, { useState } from 'react';
import { Input } from '../ui/Input';
import { Textarea } from '../ui/Textarea';
import { Button } from '../ui/Button';
import { CheckCircleIcon } from 'lucide-react';
import { useTranslation } from '../../lib/i18n';
const WEB3FORMS_ACCESS_KEY = 'b7789131-e060-4196-aa41-6a4c61a3a4d1';
const WEB3FORMS_ACTION = 'https://api.web3forms.com/submit';
export function PartnerForm() {
  const {
    lang
  } = useTranslation();
  const en = lang === 'en';
  const ru = lang === 'ru';
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitSuccess, setSubmitSuccess] = useState(false);
  const [submitError, setSubmitError] = useState<string | null>(null);
  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setSubmitError(null);
    const formData = new FormData(e.currentTarget);
    const payload: Record<string, string> = {
      access_key: WEB3FORMS_ACCESS_KEY,
      subject: 'Prijava servisnog partnera - D-TECH Solutions',
      from_name: 'D-TECH sajt - partner',
      botcheck: ''
    };
    formData.forEach((value, key) => {
      if (typeof value === 'string') payload[key] = value;
    });
    setIsSubmitting(true);
    try {
      const response = await fetch(WEB3FORMS_ACTION, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify(payload)
      });
      const result = await response.json();
      if (response.ok && result.success) {
        setIsSubmitting(false);
        setSubmitSuccess(true);
        if (typeof (window as any).gtag === 'function') {
          ;
          (window as any).gtag('event', 'generate_lead', {
            currency: 'EUR',
            value: 0,
            lead_source: 'partner_application'
          });
        }
      } else {
        setIsSubmitting(false);
        setSubmitError(en ? 'Sending failed. Please try again.' : ru ? 'Отправка не удалась. Пожалуйста, попробуйте еще раз.' : 'Slanje nije uspelo. Pokušajte ponovo.');
      }
    } catch (err) {
      setIsSubmitting(false);
      setSubmitError(en ? 'Network error. Please try again.' : ru ? 'Ошибка сети. Пожалуйста, попробуйте еще раз.' : 'Greška u mreži. Pokušajte ponovo.');
    }
  };
  if (submitSuccess) {
    return <div className="text-center py-6" data-id="element-548">
        <div className="w-14 h-14 bg-green-500 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-549">
          <CheckCircleIcon className="w-8 h-8 text-white" data-id="element-550" />
        </div>
        <h3 className="text-xl font-bold text-white mb-2" data-id="element-551">
          {en ? 'Application sent successfully!' : ru ? 'Заявка успешно отправлена!' : 'Prijava je uspešno poslata!'}
        </h3>
        <p className="text-sm text-gray-400" data-id="element-552">
          {en ? 'We will contact you shortly.' : ru ? 'Мы свяжемся с вами в ближайшее время.' : 'Kontaktiraćemo vas u najkraćem roku.'}
        </p>
      </div>;
  }
  return <form onSubmit={handleSubmit} className="space-y-5" noValidate data-id="element-553">
      <Input label={en ? 'Full name *' : ru ? 'Полное имя *' : 'Ime i prezime *'} type="text" name="Ime_i_prezime" required placeholder={en ? 'Your full name' : ru ? 'Ваше полное имя' : 'Vaše ime i prezime'} data-id="element-554" />

      <Input label={en ? 'Company name' : ru ? 'Название компании' : 'Naziv firme'} type="text" name="Naziv_firme" placeholder={en ? 'Company name (optional)' : ru ? 'Название компании (необязательно)' : 'Naziv firme (opciono)'} data-id="element-555" />

      <Input label={en ? 'City / District *' : ru ? 'Город / Округ *' : 'Grad / Okrug *'} type="text" name="Grad" required placeholder={en ? 'Your city or district' : ru ? 'Ваш город или округ' : 'Vaš grad ili okrug'} data-id="element-556" />

      <div className="grid grid-cols-1 md:grid-cols-2 gap-5" data-id="element-557">
        <Input label={en ? 'Phone *' : ru ? 'Телефон *' : 'Telefon *'} type="tel" name="Telefon" required placeholder={en ? '+1 ...' : ru ? '+7 ...' : '+381 ...'} data-id="element-558" />
        <Input label={en ? 'Email *' : 'Email *'} type="email" name="email" required placeholder={en ? 'your@email.com' : ru ? 'vas@email.com' : 'vas@email.com'} data-id="element-559" />
      </div>

      <Input label={en ? 'Years of experience *' : ru ? 'Опыт работы (лет) *' : 'Godine iskustva *'} type="text" name="Godine_iskustva" required placeholder={en ? 'e.g. 5 years' : ru ? 'напр. 5 лет' : 'npr. 5 godina'} data-id="element-560" />

      <Textarea label={en ? 'Brief description of past work *' : ru ? 'Краткое описание прошлого опыта работы *' : 'Kratak opis dosadašnjeg rada *'} name="Opis_rada" required placeholder={en ? 'Describe your experience...' : ru ? 'Опишите ваш опыт...' : 'Opišite vaše iskustvo...'} rows={4} data-id="element-561" />

      {submitError && <div className="p-4 bg-red-500/10 border-2 border-red-500/50 rounded-industrial text-sm text-red-300" data-id="element-562">
          {submitError}
        </div>}

      <Button type="submit" variant="primary" size="lg" disabled={isSubmitting} className="w-full" data-id="element-563">
        {isSubmitting ? en ? 'Sending...' : ru ? 'Отправка...' : 'Slanje...' : en ? 'Apply for service partnership' : ru ? 'Подать заявку на сервисное партнерство' : 'Prijavite se za servisnu saradnju'}
      </Button>

      <p className="text-xs text-gray-500 text-center" data-id="element-564">
        {en ? 'All data is used exclusively for application evaluation purposes.' : ru ? 'Все данные используются исключительно в целях оценки заявки.' : 'Svi podaci se koriste isključivo u svrhu evaluacije prijave.'}
      </p>
    </form>;
}